import { Fragment, useEffect, useState, type FC } from "react"
import { IconButton, Stack } from "@mui/material"
import Badge, { BadgeProps } from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import { NotificationIcon } from "../../../assets/icons/icons"

type NotificationBellProps = {
  unreadNotifications?: number
  lastNotificationIdentifier?: string
  showNotificactionModal?: boolean
  notificationIconBackGroundColor?: string
  onClick: () => void
}

const NotificationBellButton: FC<NotificationBellProps> = (props) => {
  const { unreadNotifications, lastNotificationIdentifier, notificationIconBackGroundColor, ...rest} = props
  const [animatedNotification, setAnimatedNotification] = useState(false)

  const StyledBadge = styled(Badge)<BadgeProps>(() => ({
    '& .MuiBadge-badge': {
      right: (unreadNotifications && unreadNotifications <= 99) ? 5 : 4,
      top: 4,
      color: "#ffffff",
      backgroundColor: "#226ca6",
      borderRadius: "2px",
      fontSize: "8px",
      height: "10px",
      width: (unreadNotifications && unreadNotifications <= 99) ? '12px' : '16px',
      minWidth: "auto",
      padding: "1px 3px 1px 3px",
      wordBreak: "normal"
    },
    "@keyframes bounceEffect": {
      "0%": { transform: "scale(1)" },
      "50%": { transform: "scale(1.3)" },
      "100%": { transform: "scale(1)" },
    },
    "&.bounceEffect": {
      animation: "bounceEffect 0.5s ease-in-out 1"
    }
  }));

  const RingingIcon = styled(NotificationIcon)(() => ({
    "@keyframes ringingNotificationEffect": {
      "0%": { transform: "rotate(0deg)" },
      "10%": { transform: "rotate(-10deg)" },
      "20%": { transform: "rotate(10deg)" },
      "30%": { transform: "rotate(-10deg)" },
      "40%": { transform: "rotate(10deg)" },
      "50%": { transform: "rotate(0deg)" },
    },
    "&.ringingNotificationEffect": {
      animation: "ringingNotificationEffect 0.6s ease-in-out 2"
    }
  }))

  useEffect(() => {
    setAnimatedNotification(true)
    setTimeout(() => setAnimatedNotification(false), 1000)
  }, [lastNotificationIdentifier])


  return (
    <Fragment>
      <Stack 
        id="notification-bell" 
        position={"relative"} >
        <IconButton
          size="large"
          sx={{
            padding: 0,
            backgroundColor: notificationIconBackGroundColor,
            boxShadow: "unset",
            height: "1.5rem",
            width: "1.5rem",
            borderRadius: "0%",
            "&:hover": {
              backgroundColor: notificationIconBackGroundColor ? notificationIconBackGroundColor : "unset",
              boxShadow: "unset",
            },
            "div>div": {
              height: "1.25rem",
              width: "1.25rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
            svg: {
              height: "24px",
              width: "24px",
            },
          }}
          {...rest}
        >
          {(unreadNotifications && unreadNotifications > 0) ?
            <StyledBadge className={animatedNotification ? "bounceEffect" : ""} badgeContent={unreadNotifications > 999 ? 999 : unreadNotifications} max={1000} >
              <RingingIcon className={animatedNotification ? "ringingNotificationEffect" : ""} />
            </StyledBadge >
            : <NotificationIcon />
          }
        </IconButton>
      </Stack>
    </Fragment>
  )
}

export default NotificationBellButton
